import script from "./ServiceList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceList.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceList.vue?vue&type=style&index=0&id=1e3fa6d4&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e3fa6d4"]])

export default __exports__